<template>
	<div>
		<b-img src="/images/importer/module-softbody/softbody.jpg"></b-img>
		<p>
			The Softbody module contains instructions for setting up belly- or throat-bulge support for your character. Follow the instructions in this module for setting up a heatmap texture
			for your character's mesh.
		</p>
        
		<b-img src="/images/importer/module-softbody/softbody-heatmap.jpg"></b-img>
		<p>
			This is an example of a heatmap for softbody deformation that the snow leopard in the Example scene uses. The white areas will be affected fully by deformation from the partner's cock
			during penetration, while the black areas will have no deformation.
		</p>
	</div>
</template>

<script>
export default {
		name: 'SoftbodyModule',
}
</script>
